import { PageLayout } from "../../../components";
import { extractFromQuery } from "@repo-sapiens/helpers";
import { InternalMeetingScreen } from "./InternalMeetingLayout";
import { ExternalMeetingLayout } from "./ExternalMeetingLayout";

export const MeetingScreen = () => {
  const { internal } = extractFromQuery<{ internal?: "yes" | "no" }>(
    window.location.search,
  );

  const isInternalMeeting = internal === "yes";

  return (
    <PageLayout title={`Meeting | Multiplayer`}>
      {isInternalMeeting ? (
        <InternalMeetingScreen />
      ) : (
        <ExternalMeetingLayout />
      )}
    </PageLayout>
  );
};
